import Vue from 'vue';

const success = ({ data }, resolve) => resolve(data);

const failed = () => {};

export default options => (
  new Promise((resolve, reject) => Vue.$http.post('vinmonopolet/sync', options)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    }))
);



// WEBPACK FOOTER //
// ./src/app/services/vinmonopolet/syncSelected.js